import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import Platform from '../shared/Platform';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';

export default function SocialPresence({ socialPresence, biData }) {
    if (!socialPresence.length) { return null; }

    const seller_card_about_me_social_presence_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_social_presence_impression',
        data: socialPresence
    });

    return (
        <WithImpressions value={seller_card_about_me_social_presence_impression} className="social-media-platforms">
            <h3><I18n k="user_page_perseus.seller_profile.social_presence"/></h3>
            <ul>
                {socialPresence.map((platform, idx) =>
                    <Platform platformData={platform} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

SocialPresence.propTypes = {
    socialPresence: PropTypes.array,
    biData: PropTypes.object
};

SocialPresence.defaultProps = {
    socialPresence: [],
    biData: {}
};
